import { render, staticRenderFns } from "./StoryboardAdministration.vue?vue&type=template&id=e99d9e64&scoped=true"
import script from "./StoryboardAdministration.vue?vue&type=script&lang=js"
export * from "./StoryboardAdministration.vue?vue&type=script&lang=js"
import style0 from "./StoryboardAdministration.vue?vue&type=style&index=0&id=e99d9e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99d9e64",
  null
  
)

export default component.exports